import React from 'react';
import { FadeIn, Section } from './ui';
import { X } from 'lucide-react';
export function PainSection() {
  const pains = ['Llegás al domingo a la noche y todavía no sabés qué guía vas a dar el lunes', 'Preparás un examen y a los 5 minutos ya tenés 8 manos levantadas preguntando lo mismo que acabás de explicar', 'Usás siempre los mismos ejercicios porque no tenés tiempo de buscar situaciones reales que les interesen', 'Te quedás hasta las 11 de la noche preparando materiales que otros consiguen en 15 minutos', 'Tenés alumnos con diagnóstico (TEA, TDAH, discalculia) y nadie te enseñó cómo adaptarles el examen legalmente'];
  return <Section variant="light" data-id="element-167">
      <FadeIn data-id="element-168">
        <h2 className="text-[28px] md:text-4xl font-black text-brand-orange mb-10 leading-tight" data-id="element-169">
          Si sos profe de matemática en Argentina, esto te va a sonar conocido:
        </h2>
      </FadeIn>

      <div className="space-y-3 mb-10" data-id="element-170">
        {pains.map((pain, index) => <FadeIn key={index} delay={index * 0.05} data-id="element-171">
            <div className="flex items-start gap-3 bg-dark p-4 rounded-xl border border-gray-800/50" data-id="element-172">
              <X className="text-red-500 shrink-0 mt-0.5" size={20} data-id="element-173" />
              <p className="text-gray-300 text-[15px] md:text-lg leading-relaxed" data-id="element-174">
                {pain}
              </p>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} data-id="element-175">
        <div className="bg-dark p-6 md:p-8 rounded-2xl border-l-4 border-brand-orange shadow-xl" data-id="element-176">
          <p className="text-white text-lg md:text-xl leading-relaxed font-medium" data-id="element-177">
            No es que seas mal docente. Es que nadie te enseñó el sistema. En el
            profesorado te enseñaron teoría. Nadie te dio los scripts, las
            plantillas y los protocolos para ejecutar una clase perfecta sin
            gastar 3 horas preparándola.
            <br data-id="element-178" />
            <br data-id="element-179" />
            <span className="text-brand-orange font-bold text-2xl" data-id="element-180">
              Hasta ahora.
            </span>
          </p>
        </div>
      </FadeIn>
    </Section>;
}